import React, { FunctionComponent } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { PRODUCTION_DOMAIN } from '../../../constants';

type BasicSeoElementsProps = {
  title?: string;
  description?: string;
  imageUrl?: string;
  robots?: {
    noArchive: boolean;
    noFollow: boolean;
    noIndex: boolean;
  };
};

export const BasicSeoElements: FunctionComponent<BasicSeoElementsProps> = ({
  title,
  description,
  imageUrl,
  robots,
}) => {
  const { locale, asPath } = useRouter();

  const robotsArr = [];
  if (robots?.noArchive) {
    robotsArr.push('noarchive');
  }
  if (robots?.noIndex) {
    robotsArr.push('noindex');
  }
  if (robots?.noFollow) {
    robotsArr.push('nofollow');
  }

  const href = `https://${PRODUCTION_DOMAIN}/${locale}${
    asPath !== '/' ? asPath : ''
  }`;

  return (
    <Head>
      <title>{title}</title>
      <link
        rel="icon"
        sizes="16x16"
        href={`https://static.parastorage.com/services/kb-client-nextjs/dist/public/favicons/favicon-16x16.png`}
      />
      <link
        rel="icon"
        sizes="32x32"
        href={`https://static.parastorage.com/services/kb-client-nextjs/dist/public/favicons/favicon-32x32.png`}
      />
      <link
        rel="icon"
        sizes="48x48"
        href={`https://static.parastorage.com/services/kb-client-nextjs/dist/public/favicons/favicon-48x48.png`}
      />
      <link
        rel="apple-touch-icon"
        href={`https://static.parastorage.com/services/kb-client-nextjs/dist/public/apple-touch-icon.png`}
      />
      <link
        rel="apple-touch-icon"
        href={`https://static.parastorage.com/services/kb-client-nextjs/dist/public/favicons/favicon-120x120.png`}
        sizes="120x120"
      />
      <link
        rel="apple-touch-icon"
        href={`https://static.parastorage.com/services/kb-client-nextjs/dist/public/favicons/favicon-152x152.png`}
        sizes="152x152"
      />
      <link
        rel="apple-touch-icon"
        href={`https://static.parastorage.com/services/kb-client-nextjs/dist/public/favicons/favicon-167x167.png`}
        sizes="167x167"
      />
      <link
        rel="apple-touch-icon"
        href={`https://static.parastorage.com/services/kb-client-nextjs/dist/public/favicons/favicon-180x180.png`}
        sizes="180x180"
      />
      <link
        rel="icon"
        href={`https://static.parastorage.com/services/kb-client-nextjs/dist/public/favicons/favicon-192x192.png`}
        sizes="192x192"
      />
      <base href={`//${process.env.domain}/${locale}`} />
      <meta httpEquiv="content-type" content="text/html; charset=UTF-8" />
      <meta httpEquiv="content-language" content={locale as string} />
      <meta
        name="google-site-verification"
        content="caM2lnCRLah4A1mGepO9qL_hg8cqHdh3UzqMkNMaNAA"
      />
      <meta name="description" content={description} />
      <meta name="og:description" content={description} />
      <meta name="twitter:description" content={description} />
      <meta name="og:title" content={title} />
      <meta property="og:url" content={href} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:image:src" content={imageUrl} />
      <link rel="canonical" href={href.split('?')[0]} />
      {robotsArr.length > 0 && (
        <meta name="robots" content={robotsArr.join(',')} />
      )}
      <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon"></link>
    </Head>
  );
};
